// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.documents-container {
  display: flex;
  flex-direction: column;
  gap: 80px;
  width: 100%;
}

.documents-section {
  width: 100% !important;
  margin: 0 !important;
  background: transparent;
}

.documents-header {
  background: #F3F3F3 !important;
  height: 60px;
  padding: 0 20px;
  border-radius: 8px 8px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-bottom: 1px solid #E5E7EB !important;
}

.documents-header h3 {
  color: #333 !important;
  font-family: Montserrat, sans-serif !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  margin: 0;
}

.add-document-btn {
  background: transparent;
  color: #888;
  border: 1px solid #ccc;
  border-radius: 6px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.add-document-btn:hover {
  background: #f09502;
  color: white;
  border-color: #f09502;
}

.documents-list {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 0 0 8px 8px;
  display: flex;
  flex-direction: column;
}

.document-row {
  display: flex;
  height: 60px;
  padding-left: 20px;
  padding-right: 20px;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.2s ease;
}

.document-row:last-child {
  border-bottom: none;
}

.document-row:hover {
  background-color: #fcfcfc;
}

.document-info {
  display: flex;
  align-items: center;
  gap: 1.25rem;
}

.document-icon {
  width: 32px;
  height: 32px;
  background: #FFD288;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f09502;
  font-size: 1rem;
  flex-shrink: 0;
}

.document-details {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.document-name {
  color: #333;
  font-size: 14px;
  font-weight: 500;
}

.document-meta {
  color: #888;
  font-size: 0.75rem;
}

.document-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.download-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  color: #555;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
}

.download-btn:hover {
  background: #f8f9fa;
  border-color: #ccc;
  color: #333;
}

.download-btn i {
  color: #f09502;
}

.remove-document-btn {
  background: transparent;
  color: #aaa;
  border: none;
  font-size: 1.1rem;
  cursor: pointer;
  padding: 0.5rem;
  transition: color 0.2s ease;
}

.remove-document-btn:hover {
  color: #dc3545;
}

.no-documents-text {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 0 0 10px 10px;
  padding: 2.5rem;
  text-align: center;
  color: #888;
  font-style: italic;
  font-size: 0.95rem;
}

/* ==========================================================================
   RESPONSIVE DESIGN (Top-Down Strategy: KISS & Clean Code)
   ========================================================================== */

/* --------------------------------------------------------------------------
   DESKTOP SMALL (max-width: 1280px)
   Objetivo: Reducir gaps gigantes.
   -------------------------------------------------------------------------- */
@media (max-width: 1280px) {
  .documents-container {
    gap: 60px; /* Reducido de 80px */
  }
}

/* --------------------------------------------------------------------------
   TABLET (max-width: 834px)
   Objetivo: Hacer más compacta la lista de documentos
   -------------------------------------------------------------------------- */
@media (max-width: 834px) {
  .documents-container {
    gap: 40px;
  }
  
  .documents-header {
    padding: 0 16px;
  }

  .document-row {
    padding-left: 16px;
    padding-right: 16px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/app/components/new-proyect/new-project-documents/new-project-documents.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;EAC9C,0BAA0B;EAC1B,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;+EAE+E;;AAE/E;;;+EAG+E;AAC/E;EACE;IACE,SAAS,EAAE,qBAAqB;EAClC;AACF;;AAEA;;;+EAG+E;AAC/E;EACE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF","sourcesContent":[".documents-container {\n  display: flex;\n  flex-direction: column;\n  gap: 80px;\n  width: 100%;\n}\n\n.documents-section {\n  width: 100% !important;\n  margin: 0 !important;\n  background: transparent;\n}\n\n.documents-header {\n  background: #F3F3F3 !important;\n  height: 60px;\n  padding: 0 20px;\n  border-radius: 8px 8px 0 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px solid #e0e0e0;\n  border-bottom: 1px solid #E5E7EB !important;\n}\n\n.documents-header h3 {\n  color: #333 !important;\n  font-family: Montserrat, sans-serif !important;\n  font-size: 18px !important;\n  font-weight: 500 !important;\n  margin: 0;\n}\n\n.add-document-btn {\n  background: transparent;\n  color: #888;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.add-document-btn:hover {\n  background: #f09502;\n  color: white;\n  border-color: #f09502;\n}\n\n.documents-list {\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 0 0 8px 8px;\n  display: flex;\n  flex-direction: column;\n}\n\n.document-row {\n  display: flex;\n  height: 60px;\n  padding-left: 20px;\n  padding-right: 20px;\n  align-items: center;\n  justify-content: space-between;\n  align-self: stretch;\n  border-bottom: 1px solid #e0e0e0;\n  transition: background-color 0.2s ease;\n}\n\n.document-row:last-child {\n  border-bottom: none;\n}\n\n.document-row:hover {\n  background-color: #fcfcfc;\n}\n\n.document-info {\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n}\n\n.document-icon {\n  width: 32px;\n  height: 32px;\n  background: #FFD288;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #f09502;\n  font-size: 1rem;\n  flex-shrink: 0;\n}\n\n.document-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.document-name {\n  color: #333;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.document-meta {\n  color: #888;\n  font-size: 0.75rem;\n}\n\n.document-actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.download-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  color: #555;\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n  transition: all 0.2s ease;\n}\n\n.download-btn:hover {\n  background: #f8f9fa;\n  border-color: #ccc;\n  color: #333;\n}\n\n.download-btn i {\n  color: #f09502;\n}\n\n.remove-document-btn {\n  background: transparent;\n  color: #aaa;\n  border: none;\n  font-size: 1.1rem;\n  cursor: pointer;\n  padding: 0.5rem;\n  transition: color 0.2s ease;\n}\n\n.remove-document-btn:hover {\n  color: #dc3545;\n}\n\n.no-documents-text {\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 0 0 10px 10px;\n  padding: 2.5rem;\n  text-align: center;\n  color: #888;\n  font-style: italic;\n  font-size: 0.95rem;\n}\n\n/* ==========================================================================\n   RESPONSIVE DESIGN (Top-Down Strategy: KISS & Clean Code)\n   ========================================================================== */\n\n/* --------------------------------------------------------------------------\n   DESKTOP SMALL (max-width: 1280px)\n   Objetivo: Reducir gaps gigantes.\n   -------------------------------------------------------------------------- */\n@media (max-width: 1280px) {\n  .documents-container {\n    gap: 60px; /* Reducido de 80px */\n  }\n}\n\n/* --------------------------------------------------------------------------\n   TABLET (max-width: 834px)\n   Objetivo: Hacer más compacta la lista de documentos\n   -------------------------------------------------------------------------- */\n@media (max-width: 834px) {\n  .documents-container {\n    gap: 40px;\n  }\n  \n  .documents-header {\n    padding: 0 16px;\n  }\n\n  .document-row {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
